import React from 'react';
import { useNavigate, useRouteError } from 'react-router-dom';

import { Button } from '../../components/common/Button/Button';
import { Typography } from '../../components/common/Typography/Typography';
import { APP_ROUTES } from '../../constants/routes';
import { useTranslation } from '../../hooks/useTranslation/useTranslation';
import styles from './RouteError.module.css';
import { RouteErrorProps } from './RouteError.types';

export const RouteError: React.FC<RouteErrorProps> = ({ message }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const error = useRouteError();
  const errorMessage = error instanceof Error ? error.message : undefined;

  const defaultErrorText = t.error.failedToLoad;
  const resolvedMessage = message || errorMessage || defaultErrorText;

  const handleGoHome = () => {
    navigate(APP_ROUTES.HOME);
  };

  return (
    <div className={styles.container} role="alert">
      <div className={styles.content}>
        <Typography variant="h2">{defaultErrorText}</Typography>
        {resolvedMessage !== defaultErrorText && (
          <Typography variant="body1">{resolvedMessage}</Typography>
        )}
        <Button onClick={handleGoHome} variant="primary" className={styles.homeButton}>
          {t.error.returnHome}
        </Button>
      </div>
    </div>
  );
};
